<template>
  <div class="page-wrap DeviceList-page PetAdminIncomeList" ref="container">
		<Search :label="searchLabel" :dateFilter="true" @search="search" :options="options" ref="search"></Search>
		<div class="badge">
			<div class="data-view" v-for="(item,index) in badge" :key="index">
				<div class="data-title">{{item.name}}（{{item.field}}）</div>
				<div class="data-value">¥{{item.count}}</div>
			</div>
			<div class="btn-view" @click="applyAccounts"><div class="btn">收入结算</div></div>
		</div>
		<List title="收益列表" :refresh="true" :label="label" apiName="petIncomeList" ref="list" @itemClick="itemClick" :options="options"></List>
		
		<Popup v-model="showPopup" closeable round>
			
			<div class="info-content">
				<div class="info-box">
					<div class="info-box-content">
						<div class="info-box-label">
							<div class="label-name">设备编号</div>
							<div class="label-value">{{popupInfo.machineCode}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">所属渠道</div>
							<div class="label-value">{{popupInfo.nickname}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">收益类型</div>
							<div class="label-value">{{popupInfo.priceTypeStr}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">订单信息</div>
							<div class="label-value">{{popupInfo.thirdNo}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">订单金额</div>
							<div class="label-value">{{popupInfo.thirdPrice}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">退款金额</div>
							<div class="label-value">{{popupInfo.refundPrice}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">收益金额</div>
							<div class="label-value">{{popupInfo.expectPrice}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">时间</div>
							<div class="label-value">{{popupInfo.time}}</div>
						</div>
						<div class="info-box-label">
							<div class="label-name">状态</div>
							<div class="label-value">{{popupInfo.statusStr}}</div>
						</div>
					</div>
				</div>
			</div>
			
		</Popup>
		
		
		
		
  </div>
</template>
<script>
import Search from "@components/Search";
import List from "@components/List";
import PetApi from "../../api/petAdmin";
import {Popup} from 'vant';


export default {
  name: 'PetAdminIncomeList',
  components: {
		Search,
		List,
		Popup
  },
  props: {},
  data: function() {
    return {
			options : {
				date : this.$route.params.date,
				priceType : ''
			},
			popupInfo : {},
			showPopup : false,
			badge : [],
			total : '0.00',
			searchLabel : [
				{field : 'deviceSn', title : '设备编码'},
				{field : 'priceType', title : '收益类型', type : "select"},
			],
			label : [
				{field : 'machineCode', title : '设备编码'},
				{field : 'priceTypeStr', title : '收益类型'},
				{field : 'real_name', title : '所属商家'},
				{field : 'statusStr', title : '状态'},
				{field : 'expectPrice', title : '', type : "num"},
				{field : 'time', title : '', type : "date"},
			],
    };
  },
  watch: {
		$route(n) {
		  if (n.name === 'PetAdminIncomeList') {
				let prevPage = this.$prevRoute();
				if (prevPage && prevPage.name == "PetAdmin") {
					this.options = this.$route.params
					this.options.priceType = '';
					this.$refs.search.reSet(this.options);
					this.search(this.options);
				}
		  }
		}
  },
  mounted: function() {
		this.getBadge();
  },
  computed: {},
  methods: {
		itemClick(item) {
			this.showPopup = true;
			this.popupInfo = item;
		},
		getBadge(filter) {
			let that = this;
			PetApi.petIncomeBadge({...this.options,...filter}).then(
			  res => {
					that.badge = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
		applyAccounts() {
			this.$router.push({ path: "/petAdmin/applyAccounts" });
		},
		search(filter) {
			this.$refs.list.reload(filter);
			this.getBadge(filter)
		},
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}

.badge {
	height: 2.06rem;
	margin-top: 0.4rem;
	background: #FFFFFF;
	border-radius: .2rem;
	padding:0.32rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	
	.data-view {
		.data-title {
			font-weight: 600;
			font-size: 0.36rem;
			color: #000000;
		}
		.data-value {
			margin-top: 0.08rem;
			font-weight: 500;
			font-size: 0.6rem;
			color: #F9372D;
		}
	}
	.btn-view {
		margin-right: 0.08rem;
		padding: 0.12rem 0.26rem;
		background: #F5A100;
		border-radius: 0.3rem;
		border: 0.02rem solid #F5A100;
		color: #fff;
	}
}

.PetAdminIncomeList
{
	.info-content {
		padding: 0 0.32rem;
		width: 7rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.5rem;
			padding: 0.2rem;
			position: relative;
			
			.info-box-title {
				font-weight: bold;
				font-size: .32rem;
				color: #000000;
				display: flex;
				align-items: center;
				justify-content: space-between;
				
				&.mt {
					margin-top: 0.24rem;
				}
				
				.edit-icon {
					width: .40rem;
					height: .38rem;
					background-size: 100%;
					background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAIAAAA5lk5KAAACW0lEQVRYhb3Yz2sTQRQH8PfeTjYxLUahDY0asD3EH0c91NYipIjak2cVpHgRBOvFv6CnQrE3L4LYqz8wvYhIBYWQHqwHBQ1IQ2kDKqWCNEljmpnd8bDbjcYf2e3M9nt6O7PsZ3ZmdmEXpZTgxKqL4owo52S1JJsVUA5SxOi/ZJ6eBcC/9Dqwvb7QLIzblSV1ry2xC3lKjvzZzhx168UZaVvaVWR7sPtw61haonhHVpfZsVsMrHqzMO6p1JWmvizGD2pgyWTpixg/5KnN/GWx8ggArLVXTBRnvBlmA1fMoXtgxDWobflFBQAQdRLlnDu+rvTuqGhEzeH7JKslF+7L7o4azeYodY68J0fPuvpRD4wBAOnHfKhhwv9VQ4M7qeHAPtQQYH+qbti3qhXupNrrBVlb1g13UvniROP5SGPuqL32Wh/sY4bFykMAkDa3yk81wT7X1eZthRocZDe1RQFWUBVgNXWnsLK6I1iHGhzWpAaE9anBYL44oUsNBovVJ7rUYDAbuAoAaO6NZucUVXC+JHwmcnKaHbmB0f0Q2aeoBoMBALv71UknhLg92957PIx4F0fDhSGWdLs2iiGhcrMsec11tzkyek+58Jd5+f1dGLD4OO3V1DPoFixz3R2XzRsvx6zVxyBquki5WeZvbopPd10skaHUqFOjlLK5cE2UHnhnIxKYCQ2szb0ZBgAkI3o+T71DLRj4xtb8WevbWw3YP4JkRE5MseO3Wy3uPxApxIcp/n5ShrC3KZExh2e9e/0ddvLjq/X5mV1ZAq7h5wuggbEk9QxSahQw0tb5E0FzeeLqyAO4AAAAAElFTkSuQmCC');
				}
			}
			.info-box-tips {
				position: absolute;
				top: 0;
				right: 0;
				
				color: #fff;
				font-weight: 400;
				font-size: 0.22rem;
				padding: 0.02rem 0.16rem;
				border-top-right-radius: 0.2rem;
				border-bottom-left-radius: 0.2rem;
				
				&.outline {
					background: #F7301D;
				}
				&.online {
					background: #3DC60C;
				}
			}
			.info-box-content {
				.info-box-label {
					margin-top: 0.24rem;
					display: flex;
					justify-content: space-between;
					
					.label-name {
						font-weight: 400;
						font-size: .30rem;
						color: #666666;
						width: 2.7rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .30rem;
						color: #333333;
						text-align: right;
						flex: 1;
						
						&.info {
							font-weight: 400;
							font-size: .30rem;
							color: #F5A100;
						}
					}
				}
			}
		}
	}
	
}

</style>
